import React, { useState, useEffect } from 'react';
import { Row, Button, Modal, Col, Input, Select, Divider, Table, notification } from 'antd';
import { PlusOutlined, DeleteOutlined, EditOutlined, SaveOutlined, FileAddOutlined, UploadOutlined, LoadingOutlined, SyncOutlined, FileImageOutlined } from '@ant-design/icons';


export default function CreateOrders() {
    const [modalOpenOrders, setModalOpenOrders] = useState(false)

    const handleCancel = () => {
        setModalOpenOrders(false)
    }

    const openModal = () => {
        setModalOpenOrders(true)
    }

    const saveOrder = ()=>{
        setModalOpenOrders(false)
        openNotificationWithIcon('success', 'Order create successfully')
    }

    const openNotificationWithIcon = (type, mensaje) => {
        notification[type]({
            description: mensaje
        });
    };

    return (
        <div>
            <Row gutter={24} style={{ marginBottom: '20px' }}>
                <Button
                    onClick={openModal}
                    type='primary'
                    size='large'
                    style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                >
                    <PlusOutlined />
                    Create Orders
                </Button>
            </Row>

            <Modal
                title="Create Orders"
                visible={modalOpenOrders}
                onCancel={handleCancel}
                width={700}
                footer={null}
                closable={true}
            >
                <Row gutter={24}>
                    <Col span={12} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>Client name</label>
                        <Input
                            type='text'
                            size='large'

                        // onChange={handleInputChange}


                        />
                    </Col>
                    <Col span={12} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}></span>Alias</label>
                        <Input
                            type='text'
                            size='large'

                        // onChange={handleInputChange}


                        />
                    </Col>
                    <Col span={12} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>Phone number</label>
                        <Input
                            type='text'
                            size='large'

                        // onChange={handleInputChange}


                        />
                    </Col>
                    <Col span={12} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>Address</label>
                        <Input
                            type='text'
                            size='large'

                        // onChange={handleInputChange}


                        />
                    </Col>
                    <Col span={12} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}></span>Note</label>
                        <Input
                            type='text'
                            size='large'

                        // onChange={handleInputChange}


                        />
                    </Col>
                    <Col span={12} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>City</label>
                        <Input
                            type='text'
                            size='large'

                        // onChange={handleInputChange}


                        />
                    </Col>
                    <Col span={12} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}></span>State</label>
                        <Input
                            type='text'
                            size='large'

                        // onChange={handleInputChange}


                        />
                    </Col>
                    <Col span={12} className='formMarginInput'>
                        <label htmlFor=""><span style={{ color: 'red' }}>*</span>Zip code</label>
                        <Input
                            type='text'
                            size='large'

                        // onChange={handleInputChange}


                        />
                    </Col>

                    <Col span={24}>
                        <Button
                            onClick={saveOrder}
                            type='primary'
                            size='large'
                            style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5, marginTop: '10px' }}
                        >
                            <SaveOutlined />
                            Save Order
                        </Button>
                    </Col>

                </Row>

            </Modal>
        </div>
    )

}